import { useState } from "react";

import Grid from "@mui/material/Grid2";
import dayjs, { Dayjs } from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Typography from "@mui/material/Typography";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TextareaAutosize from "@mui/material/TextareaAutosize";

import GridSectionHeader from "../../widgets/GridSectionHeader";
import GridTextfield from "../../widgets/GridTextfield";
import GridCheckbox from "../../widgets/GridCheckbox";

import { reDecimalNumbers } from "../../../utils/fieldValidator.js";
import { MAX_LENGTH_TEXTAREA } from "../../../utils/constants.js";

export default function ExistingInsurance() {
  const [insuranceDisclosure, setInsuranceDisclosure] = useState("");
  const [existingInvestmentDesc, setExistingInvestmentDesc] = useState();

  const [isHospostalPlanCover, setIsHospostalPlanCover] = useState();
  const [owner, setOwner] = useState("");
  const [commencementDate, setCommencementDate] = useState(dayjs());
  const [isCommDateAccurate, setIsCommDateAccurate] = useState();
  const [compAndPolicyType, setCompAndPolicyType] = useState();

  const [annualPremium, setAnnualPremium] = useState();
  const [sumDeath, setSumDeath] = useState();
  const [sumDisability, setSumDisability] = useState();
  const [sumCriticalIllness, setSumCriticalIllness] = useState();
  const [sumPersonalAccident, setSumPersonalAccident] = useState();
  const [sumMaternity, setSumMaternity] = useState();
  const [sumLongTermCare, setSumLongTermCare] = useState();
  const [sumMaturityCashValue, setSumMaturityCashValue] = useState();

  function handleInsuranceDisclosureChange(e) {
    setInsuranceDisclosure(e.target.value);
  }

  function handleIsHospotalPlanCoverChange(e) {
    setIsHospostalPlanCover(e.target.checked);
  }

  function handleOwnerChange(e) {
    setOwner(e.target.value);
  }

  function handleCommencementDateChange(newDate) {
    setCommencementDate(newDate);
  }

  function handleIsCommDateAccurateChange(e) {
    setIsCommDateAccurate(e.target.checked);
  }

  function handleCompAndPolicyTypeChange(e) {
    setCompAndPolicyType(e.target.value);
  }

  function handleAnnualPremiumChange(e) {
    if (reDecimalNumbers.test(e.target.value)) setAnnualPremium(e.target.value);
  }
  function handleSumDeathChange(e) {
    if (reDecimalNumbers.test(e.target.value)) setSumDeath(e.target.value);
  }
  function handleSumDisabilityChange(e) {
    if (reDecimalNumbers.test(e.target.value)) setSumDisability(e.target.value);
  }
  function handleSumCriticalIllnessChange(e) {
    if (reDecimalNumbers.test(e.target.value))
      setSumCriticalIllness(e.target.value);
  }
  function handleSumPersonalAccidentChange(e) {
    if (reDecimalNumbers.test(e.target.value))
      setSumPersonalAccident(e.target.value);
  }
  function handleSumMaternityChange(e) {
    if (reDecimalNumbers.test(e.target.value)) setSumMaternity(e.target.value);
  }
  function handleSumLongTermCareChange(e) {
    if (reDecimalNumbers.test(e.target.value))
      setSumLongTermCare(e.target.value);
  }
  function handleSumMaturityCashValueChange(e) {
    if (reDecimalNumbers.test(e.target.value))
      setSumMaturityCashValue(e.target.value);
  }

  function handleExistingInvestmentDescChange(e) {
    if (e.target.value.length <= MAX_LENGTH_TEXTAREA)
      setExistingInvestmentDesc(e.target.value);
  }

  return (
    <Grid container spacing={2}>
      {/* EXISTING INVEStMENTS */}
      <GridSectionHeader
        sectionName="Existing Insurance"
        sx={{
          p: 1,
          pl: 1.8,
          mt: 0,
          mb: 1,
          fontSize: 18,
          fontWeight: "bold",
          color: "#FFFFFF", //WHITE
          // color: "#000000", //BLACK
          // backgroundColor: "#d9d9d9",
          backgroundColor: "#10B981",
        }}
      />

      {/*==============================
        EXISTING INSURANCE - DECLARATION
      ==============================*/}
      <Typography variant="h6" gutterBottom>
        Do you have any exisitng insurance to disclose?
      </Typography>

      <RadioGroup
        name="insurance-disclosure"
        defaultValue=""
        value={insuranceDisclosure}
        onChange={handleInsuranceDisclosureChange}
      >
        <FormControlLabel
          id="insuranceYes"
          value="INSURANCE_YES"
          control={<Radio />}
          label="Yes, I have existing insurance to disclose."
        />

        <FormControlLabel
          id="insuranceNo"
          value="INSURANCE_NO"
          control={<Radio />}
          label="I do not have any insurance."
        />

        <FormControlLabel
          id="insuranceConfidential"
          value="INSURANCE_CONFIDENTIAL"
          control={<Radio />}
          label="I do not wish to disclose my existing insurance information and for it to be taken into consideration for needs analysis and recommendations."
        />
      </RadioGroup>

      {/*==============================
        EXISTING INVESTMENT - DETAILS
        ==============================*/}
      {insuranceDisclosure === "INSURANCE_YES" ? (
        <>
          <Typography variant="body1" gutterBottom>
            Hospital Plan Cover
          </Typography>

          <GridCheckbox
            id="hospitalPlanCover"
            columnSize="12"
            label="This is a hospital plan cover."
            disabled={false}
            onChange={handleIsHospotalPlanCoverChange}
          />

          <GridTextfield
            id="owner"
            columnSize="6"
            label="Owner"
            required={false}
            currState={owner}
            onChange={handleOwnerChange}
          />

          {/* COMMENCEMENT DATE */}
          <Grid size={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format="DD MMM YYYY"
                label="Commencement Date"
                value={commencementDate}
                onChange={(newDate) => handleCommencementDateChange(newDate)}
              />
            </LocalizationProvider>
          </Grid>

          <GridCheckbox
            id="isCommencementDateAccurate"
            columnSize="3"
            label="I cannot remember."
            disabled={false}
            onChange={handleIsCommDateAccurateChange}
          />

          <GridTextfield
            id="compAndPolicyType"
            columnSize="6"
            label="List Company & Policy Type"
            required={false}
            currState={compAndPolicyType}
            onChange={handleCompAndPolicyTypeChange}
          />

          <GridTextfield
            id="annualPremium"
            columnSize="6"
            label="Annual Premium"
            required={false}
            currState={annualPremium}
            onChange={handleAnnualPremiumChange}
          />

          <GridTextfield
            id="sumDeath"
            columnSize="6"
            label="Sum Assured - Death"
            required={false}
            currState={sumDeath}
            onChange={handleSumDeathChange}
          />

          <GridTextfield
            id="sumDisability"
            columnSize="6"
            label="Sum Assured - Total Permanent Disability"
            required={false}
            currState={sumDisability}
            onChange={handleSumDisabilityChange}
          />

          <GridTextfield
            id="sumCriticalIllness"
            columnSize="6"
            label="Sum Assured - Critical Illness"
            required={false}
            currState={sumCriticalIllness}
            onChange={handleSumCriticalIllnessChange}
          />

          <GridTextfield
            id="sumPersonalAccident"
            columnSize="6"
            label="Sum Assured - Personal Accident"
            required={false}
            currState={sumPersonalAccident}
            onChange={handleSumPersonalAccidentChange}
          />

          <GridTextfield
            id="sumMaternity"
            columnSize="6"
            label="Sum Assured - Maternity"
            required={false}
            currState={sumMaternity}
            onChange={handleSumMaternityChange}
          />

          <GridTextfield
            id="sumLongTermCare"
            columnSize="6"
            label="Monthly Benefit - Long Term Care / Disability Invome"
            required={false}
            currState={sumLongTermCare}
            onChange={handleSumLongTermCareChange}
          />

          <GridTextfield
            id="sumMaturityCashValue"
            columnSize="6"
            label="Cash Value / Maturity"
            required={false}
            currState={sumMaturityCashValue}
            onChange={handleSumMaturityCashValueChange}
          />
        </>
      ) : (
        ""
      )}

      {/*==============================
        EXISTING INVESTMENT - ADDITIONAL NOTES
        ==============================*/}
      {insuranceDisclosure === "INSURANCE_CONFIDENTIAL" ? (
        <>
          <Grid size={12}>
            <Typography variant="body1">Additional Notes</Typography>

            <TextareaAutosize
              id="existingInvestmentDesc"
              placeholder="Type here..."
              style={{ width: "100%" }}
              minRows={5}
              onChange={handleExistingInvestmentDescChange}
            />
          </Grid>
        </>
      ) : (
        ""
      )}
    </Grid>
  );
}
